import { FirebaseApp } from 'firebase/app';
import { AssignmentStore } from './stores/assignment-store';
import { UserPreferencesStore } from './stores/userpreference-store';
import { CurrentUser } from './models/CurrentUser';
import { BaseView } from './views/base-view';
import { Employee } from './models/Employee';
import { LoginHandler } from './login-handler';
import { AssignmentDemand } from './models/AssignmentDemand';

export class PageContext {
    /** @type {AssignmentStore} */
    store: AssignmentStore;
    /** @type {UserPreferencesStore} */
    userPreferences: UserPreferencesStore;
    /** @type {object} */
    params: any = null;
    /** @type {CurrentUser} */
    user!: CurrentUser;
    /** @type {BaseView | null} */
    view: BaseView | null = null;
    /** @type {Array} */
    history: any = [];
    data: any;
    employeeData: Employee | null | undefined;
    authentication!: LoginHandler;
    activeDemandDetailId: string | null = null;
    projectAssignments!: AssignmentDemand[];

    skillStructure!: { [key: string]: string[] };
    isoLanguageOptions!: { label: string; name: string; value: string; }[];
    constructor(fireApp: FirebaseApp) {
        this.store = new AssignmentStore(fireApp);
        this.userPreferences = new UserPreferencesStore(fireApp);
    }
}